import React, { useState, createContext } from "react";
import { Auth, API } from "aws-amplify";
import Loading from "../components/common/Loading";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [fetchList, setfetchList] = useState([]);
  const [filterList, setfilterList] = useState([]);
  const [loginUserDetails, setLoginUserDetails] = useState({});
  const [logoInfo, setLogoInfo] = useState({});
  const [appInfo, setAppInfo] = useState({});

  const [profileDetails, setProfileDetails] = useState({});
  const [isLoadingMore, setLoadingMore] = useState(false);
  const [recordsLimit, setRecordsLimit] = useState(25);
  const [nextKey, setNextKey] = useState("");
  const [prevKey, setPrevKey] = useState("");
  const [switchOrgList, setSwitchOrgList] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");

  const getMasterInfo = async (userId) => {
    await API.get("list", `/noAuth/getMasterData`, {})
      .then((response) => {
        if (
          response.orgLogo !== undefined &&
          response.orgLogo !== null &&
          response.orgLogo !== ""
        ) {
          let logoInfo = {
            appLogo: response.orgLogo,
            enableGlobalLogo: true,
          };
          setLogoInfo(logoInfo);
        } else {
          let logoInfo = {
            appLogo: "",
            enableGlobalLogo: false,
          };
          setLogoInfo(logoInfo);
        }

        if (response && response.settings) {
          let appInfo = response.settings;
          let appDetails = {
            signupHelpWording: appInfo.signUpHelpWording,
            loginWording: appInfo.loginWording,
            enableFRlogin: appInfo.firstresponderAccess,
            enableAddHelp: appInfo.showAdditionalHelpInfo,
          };
          setAppInfo(appDetails);
        }
      })
      .catch((error) => {
        console.log("responser error", error);
        // dologOut();
      });
  };

  const getLoginUserInfo = async (userId) => {
    await API.get("list", `/general/get/users/${userId}?count=true`, {})
      .then((res) => {
        setLoginUserDetails(res);
      })
      .catch((error) => {
        console.log("responser error", error);
        // dologOut();
      });
  };

  const fetchUserInfo = async () => {
    setLoading(true);
    let loginUserId = loginUserDetails?.id;
    let orgId = localStorage.getItem("loginOrgId");
    let userProfile = loginUserDetails?.userProfile;
    if (loginUserId !== undefined && orgId !== undefined) {
      if (userProfile === "F") {
        if (loginUserDetails?.isGroupLevel === true) {
          getGroupOrgInfo();
        } else {
          getFirstresponderProfiles(orgId, loginUserId, null);
        }
      } else if (userProfile === "C" || userProfile === "SN") {
        getCaregiverProfiles(loginUserId);
      } else {
        alert("Don't have access!");
        setLoading(false);
      }
    }
  };

  const getGroupOrgInfo = async () => {
    setLoading(true);
    let orgId = localStorage.getItem("loginOrgId");
    let groupOrgId = localStorage.getItem("loginGroupOrgId");
    await API.get("list", `/mobile/list/groupOrgIds/${groupOrgId}`, {})
      .then(async (res) => {
        if (res?.length > 0) {
          setSwitchOrgList(res);
          if (groupOrgId && groupOrgId !== orgId && orgId) {
            getSelectedOrg(res, orgId);
          } else {
            localStorage.setItem("loginOrgId", res[0]?.id);
            getSelectedOrg(res, res[0]?.id);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("responser error", error);
      });
  };

  const getSelectedOrg = async (orgList, orgId) => {
    setShowInfo(false);
    let orgName = "";
    if (orgList?.length > 0) {
      let orgInfo = orgList.find((org) => org.id === orgId);
      if (orgInfo?.orgName !== undefined && orgInfo.orgName !== null) {
        orgName = orgInfo.orgName;
      }
    }
    setSelectedOrg(orgName);
    const userId = loginUserDetails?.id;
    const groupOrgId = localStorage.getItem("loginGroupOrgId");
    getFirstresponderProfiles(orgId, userId, groupOrgId);
  };

  const getFirstresponderProfiles = async (orgId, loginUserId, groupOrgId) => {
    setLoading(true);
    let url =
      groupOrgId !== undefined && groupOrgId !== null
        ? `/mobile/list/orgUsersForFirstResponder/${orgId}/${loginUserId}?groupId=${groupOrgId}`
        : `/mobile/list/orgUsersForFirstResponder/${orgId}/${loginUserId}`;
    await API.get("list", url, {})
      .then((response) => {
        if (response.length > 0) {
          let profilesList = response?.sort((a, b) =>
            a?.addIndivualData?.firstName?.toLowerCase() >
            b?.addIndivualData?.firstName?.toLowerCase()
              ? 1
              : -1
          );
          setfetchList(profilesList);
          setfilterList(profilesList);
          setLoading(false);
        } else {
          setfetchList([]);
          setfilterList([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error:", error.response);
      });
  };

  const getCaregiverProfiles = async (loginUserId) => {
    await API.get(
      "list",
      `/mobile/list/getUserProfilesByPagination/${loginUserId}?limit=${recordsLimit}`,
      {}
    )
      .then(async (data) => {
        var response = data.profiles;
        setNextKey(data.nextKey);
        setPrevKey(data.prevKey);
        if (data?.nextKey !== null) {
          setLoadingMore(true);
        } else {
          setLoadingMore(false);
        }
        if (response && response.length === 0) {
          setLoading(false);
        } else if (response && response.length === 1) {
          setfetchList(response);
          setfilterList(response);
          setLoading(false);
        } else {
          setLoading(false);
          setfetchList(response);
          setfilterList(response);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error:", error.response);
      });
  };

  const getMoreProfilesData = async () => {
    setLoadingMore(true);
    let loginUserId = loginUserDetails?.id;
    if (nextKey != null) {
      await API.get(
        "list",
        `/mobile/list/getUserProfilesByPagination/${loginUserId}?limit=${recordsLimit}&key=${nextKey}`,
        {}
      )
        .then(async (data) => {
          var response = data.profiles;
          setNextKey(data.nextKey);
          setPrevKey(data.prevKey);
          setfetchList([...fetchList, ...response]);
          setfilterList([...filterList, ...response]);
          if (data?.nextKey !== null) {
            setLoadingMore(true);
          } else {
            setLoadingMore(false);
          }
        })
        .catch((error) => {
          setLoadingMore(false);
          console.log("Error:", error.response);
        });
    } else {
      setLoadingMore(false);
    }
  };

  const getProfileDetails = async (profileId, orgId) => {
    setLoading(true);
    await API.get("list", `/mobile/get/userProfile/${profileId}/${orgId}`, {})
      .then((response) => {
        if (response) {
          setProfileDetails(response);
          setLoading(false);
          setShowInfo(true);
        } else {
          setLoading(false);
          setShowInfo(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setShowInfo(false);
        alert("Something went wrong");
        console.log("Error:", error.response);
      });
  };

  const getProfilesList = (action) => {
    let profilesList = action
      ? fetchList
      : fetchList.filter((profile) => profile.firstResponderAccess === true);
    return profilesList;
  };

  const getCaregiverProfilesList = (action) => {
    let profilesList = action
      ? fetchList.filter((profile) => {
          if (profile.isActive) {
            return profile;
          }
        })
      : fetchList.filter((profile) => {
          if (profile.isExpired || !profile.isActive) {
            return profile;
          }
        });
    return profilesList;
  };

  const dologOut = async () => {
    try {
      await Auth.signOut();
      initialState();
      localStorage.clear();
      window.location.replace("/");
      return true;
    } catch (exception) {
      console.log("Error", exception);
      return false;
    }
  };

  const initialState = () => {
    setLoadingMore(false);
    setLoading(false);
    setShowInfo(false);
    setfetchList([]);
    setLoginUserDetails({});
    setProfileDetails({});
  };

  return (
    <AppContext.Provider
      value={{
        initialState,

        loading,
        setLoading,
        showInfo,
        setShowInfo,

        loginUserDetails,
        setLoginUserDetails,
        getLoginUserInfo,

        fetchList,
        filterList,
        setfetchList,
        fetchUserInfo,
        getProfilesList,
        getCaregiverProfilesList,

        switchOrgList,
        selectedOrg,
        getSelectedOrg,

        profileDetails,
        setProfileDetails,
        getProfileDetails,

        getCaregiverProfiles,

        getMoreProfilesData,
        isLoadingMore,
        nextKey,
        prevKey,

        dologOut,

        getMasterInfo,
        logoInfo,
        appInfo,
      }}
    >
      {children}
      <Loading enableLoading={loading} />
    </AppContext.Provider>
  );
};
export default AppContext;
